import Vue from "vue";
import VueRouter from "vue-router";

import Index1 from "./componentss/index1";//./components/blog.vue
import Index2 from "./componentss/blog.vue";
import Index3 from "./componentss/blog.vue";
import Index4 from "./componentss/blog.vue";
import Index5 from "./componentss/blog.vue";
import Index6 from "./componentss/blog.vue";
import Index7 from "./componentss/blog.vue";
import Index8 from "./componentss/blog.vue";
import Index9 from "./componentss/blog.vue";
import Login from "./componentss/blog.vue";
import Signup from "./componentss/blog.vue";
import Forgotpassword from './componentss/blog.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "index-1",
    component: Index1
  },
  {
    path: "/index-1",
    name: "管理工具",
    component: Index2
  },
  {
    path: "/index-2",
    name: "Index-3",
    component: Index3
  },
  {
    path: "/index-3",
    name: "Index-4",
    component: Index4
  },
  {
    path: "/index-4",
    name: "Index-5",
    component: Index5
  },
  {
    path: "/index-5",
    name: "Index-6",
    component: Index5
  },
  {
    path: "/index-6",
    name: "Index-7",
    component: Index6
  },
  {
    path: "/index-7",
    name: "Index-8",
    component: Index7
  },
  {
    path: "/index-8",
    name: "Index-9",
    component: Index8
  },
  {
    path: "/index-9",
    name: "Index-10",
    component: Index9
  },
  {
    path: "/login",
    name: "Login page",
    component: Login
  },
  {
    path: "/signup",
    name: "Signup page",
    component: Signup
  },
  {
    path: '/password_forgot',
    name: 'Forgot Password page',
    component: Forgotpassword
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
